import {getSystemLangId} from "../lang/index"

import { i18n } from "@lingui/core";
import * as messageFR from "./fr/messages.mjs";
import * as messageEN from "./en/messages.mjs";
import * as messageHE from "./he/messages.mjs";


export function loadI18n(){
	i18n.load("fr", messageFR.messages);
	i18n.load("en", messageEN.messages);
	i18n.load("he", messageHE.messages);

	i18n.activate(getSystemLangId());
}
